import React, { useContext, useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { Button, useMediaQuery, useTheme } from "@mui/material";
import { GlobalContext } from "../Utils/Contexts";
import SyncIcon from "@mui/icons-material/Sync";
import { SyncStatus } from "../Utils/Interfaces";

const NBSP = "\u00A0";

export default function ConnectionMonitor(): JSX.Element {
    const theme = useTheme();
    const context = useContext(GlobalContext);
    const showFullName = useMediaQuery(theme.breakpoints.up("md"));

    const [progress, setProgress] = useState(0);

    useEffect(() => {
        if (context.loggedInUser) {
            return;
        }

        const timeout = setTimeout(() => {
            setProgress((prev) => {
                if (prev === 3) {
                    return 0;
                }
                return prev + 1;
            });
        }, 500);

        return () => {
            clearTimeout(timeout);
        };
    }, [context.loggedInUser, progress]);

    function getProgressString(value: number) {
        let result = "";
        for (let i = 0; i < value; i++) {
            result += ".";
        }
        for (let i = 0; i < 3 - value; i++) {
            result += NBSP;
        }
        return result;
    }

    const buttonColor = context.syncStatus === SyncStatus.Fresh ? "secondary" : "warning";

    function handleSyncOnClick() {
        context.setShouldSync(true);
    }

    if (context.loggedInUser) {
        const displayName = showFullName
            ? (context.loggedInUser.first_name ?? "") + NBSP + (context.loggedInUser.last_name ?? "")
            : (context.loggedInUser.first_name ?? " ").substring(0, 1) + (context.loggedInUser.last_name ?? " ").substring(0, 1);

        return (
            <>
                <Button sx={{ ml: 3 }} color={buttonColor} variant="contained" onClick={handleSyncOnClick}>
                    <SyncIcon />
                </Button>
                <Typography variant="body1" sx={{ pl: 2 }}>
                    {displayName.toLocaleUpperCase()}
                </Typography>
            </>
        );
    } else {
        return (
            <>
                <Typography sx={{ marginLeft: 2 }}>CONNECTING{getProgressString(progress)}</Typography>
            </>
        );
    }
}
